var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlreadyDelivered = function SvgAlreadyDelivered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 113,
    viewBox: "0 0 108 113",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    filterUnits: "objectBoundingBox",
    id: "already-delivered_svg__a"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    filterUnits: "objectBoundingBox",
    id: "already-delivered_svg__b"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 11)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.573 38.746)",
    fill: "#5EACED"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.476,
    cy: 2.197,
    rx: 2.184,
    ry: 2.197
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.805,
    cy: 2.197,
    rx: 2.184,
    ry: 2.197
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.408 4.993c-1.104 0-1.426.686-.677 1.499 0 0 2.074 2.893 4.764 2.893 2.742 0 4.83-2.906 4.83-2.906.728-.82.423-1.486-.688-1.486h-8.229Z",
    stroke: "#5EACED"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.69.093h13.65v33.088c0 1.104-.688 1.428-1.54.72L9.453 31.12c-.85-.707-2.259-.748-3.143-.094l-4.017 2.97c-.886.654-1.604.282-1.604-.815V.093Z",
    filter: "url(#already-delivered_svg__a)",
    transform: "translate(75.764 1)",
    fill: "#20455E",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E2F2FE",
    y: 2.39,
    width: 108,
    height: 73.737,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.225 39.326)",
    fill: "#5EACED"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.151,
    cy: 2.163,
    rx: 2.151,
    ry: 2.163
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.351,
    cy: 2.163,
    rx: 2.151,
    ry: 2.163
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.207 4.78c-1.106 0-1.43.684-.677 1.5 0 0 2.02 2.824 4.668 2.824 2.699 0 4.732-2.837 4.732-2.837.729-.821.427-1.488-.67-1.488h-8.053Z",
    stroke: "#5EACED"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3.004A3.004 3.004 0 0 1 3.001 0H105A3.002 3.002 0 0 1 108 3.004V15.77H0V3.004Z",
    fill: "#5EACED"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.72 6.008)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.867,
    cy: 1.878,
    rx: 1.867,
    ry: 1.878
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.093,
    cy: 1.878,
    rx: 1.867,
    ry: 1.878
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.32,
    cy: 1.878,
    rx: 1.867,
    ry: 1.878
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 27.627,
    y: 6.008,
    width: 73.173,
    height: 3.755,
    rx: 1.878
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74.599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.679 2.253h13.44v32.54c0 1.109-.69 1.434-1.532.734l-3.264-2.712c-.846-.702-2.252-.74-3.145-.08l-3.885 2.872c-.892.659-1.614.304-1.614-.814V2.253Z",
    fill: "#20455E",
    opacity: 0.1,
    filter: "url(#already-delivered_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.276 0H2.402C1.788 0 1.132.478.934 1.074l-.391 1.18h2.24L4.276 0Z",
    fill: "#86389F"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "already-delivered_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", null)), /*#__PURE__*/React.createElement("use", {
    fill: "#CD68ED"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD68ED",
    mask: "url(#already-delivered_svg__c)",
    d: "M.95-8.261h18.667v44.31H.95z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F3F6F9",
    cx: 54,
    cy: 89.61,
    rx: 39.6,
    ry: 2.39
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h108v113H0z"
  }))));
};
export default SvgAlreadyDelivered;